import React from 'react';
import classNames from 'classnames';
import RangeFilterWrapper from 'components/RangeFilterWrapper';
import { useTranslation } from 'react-i18next';
import CollectionIcon from 'icons/Collection.icon';

import './EbidtaRangeFilter.styles.scss';

type EbidtaRangeFilterProps = {
  className?: string;
};

export const ONE_MIL = 1000000;
export const TWO_MILL = 2000000;
export const PRICE_RANGE_STATE_VALS = {
  UNDER_MIN: 'under1m',
  BETWEEN_VALUES: '1to2m',
  ABOVE_MAX: 'above2m',
};

const EbidtaRangeFilter: React.FC<EbidtaRangeFilterProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  const classes = classNames('ebidta-range-filter', className);

  return (
    <RangeFilterWrapper
      className={classes}
      paramsKeywords={{ fromKeyword: 'ebitdaFrom', toKeyword: 'ebitdaTo' }}
      triggerText={t('ebitda')}
      applyButtonText={t('applyEbitdaRange')}
      selectValues={{
        minValue: ONE_MIL,
        maxValue: TWO_MILL,
        copies: PRICE_RANGE_STATE_VALS,
      }}
      triggerIcon={CollectionIcon}
      isEbidta
    />
  );
};

export default EbidtaRangeFilter;
